import React, { useState } from 'react';
import useRolesService from './verRolesService';
import { createContext, useContext } from "react";

export const VerRolesContext = createContext({});
export function useRoles() {
    return useContext(VerRolesContext);
}

export function VerRolesProvider({ children }) {
    const rolesMethods = useProvideRoles();

    return (
        <VerRolesContext.Provider value={rolesMethods}>
            {children}
        </VerRolesContext.Provider>
    );
}

function useProvideRoles() {
    const rolesService = useRolesService();
    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);

    const getRoles = async () => {
        try {
            const response = await rolesService.getRoles();
            setRoles(response)
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los roles: ',
                error
            );
        }
    };

    const getUsers = async () => {
        try {
            const response = await rolesService.getUsers();
            setUsers(response)
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los usuarios: ',
                error
            );
        }
    };

    const getUserByUsername = async (username) => {
        try {
            const response = await rolesService.getUserByUsername(username);
            setUsers(response)
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los usuarios por nombre de usuario: ',
                error
            );
        }
    };

    const getUserRoles = async (userId) => {
        try {
            const response = await rolesService.getUserRoles(userId);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los roles del usuario: ',
                error
            );
        }
    };

    const getAreaRoles = async (areaId) => {
        try {
            const response = await rolesService.getAreaRoles(areaId);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los roles del área: ',
                error
            );
        }
    };

    return {
        roles,
        users,
        getRoles,
        getUserByUsername,
        getUsers,
        getAreaRoles,
        getUserRoles
    };
}
